module.exports = __webpack_public_path__ + "img/img3.5f95edd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img3.jpg
// module id = 296
// module chunks = 0